import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiInfo } from 'react-icons/fi';

const Boundary = () => {
  return (
    <section className="py-12 px-6 max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-dc-bg rounded-2xl p-6 md:p-8 border border-dc-teal-deep/10"
      >
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 bg-dc-teal-deep/10 rounded-full flex items-center justify-center">
            <SafeIcon icon={FiInfo} className="w-5 h-5 text-dc-teal-deep" />
          </div>
          <div>
            <h4 className="font-semibold text-dc-teal-deep mb-2 text-sm uppercase tracking-wider font-display">
              Clear Boundaries
            </h4>
            <p className="text-sm text-dc-text/70 leading-relaxed">
              These memberships are designed for intelligence, direction, access, visibility, connection, directory presence, and quarterly guidance. They do not include unlimited private support, guaranteed referrals, guaranteed revenue, or custom implementation work.
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Boundary;